import React from 'react';

// Scoped styles + fonts for the Company subpage (fonts, mono, scroll-focus tenets, mosaic tiles).
export const CompanyStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=JetBrains+Mono:wght@400;500;600;700&family=Caveat:wght@600&display=swap');

    .company-root { font-family: 'Inter', sans-serif; -webkit-font-smoothing: antialiased; scroll-behavior: smooth; }
    .company-root .mono, .company-root .font-mono { font-family: 'JetBrains Mono', monospace; }
    .company-root .font-sans { font-family: 'Inter', sans-serif; }
    .company-root .font-script { font-family: 'Caveat', cursive; }
    .company-root .editorial-lead { letter-spacing: -0.025em; line-height: 1.15; }
    .company-root section[id] { scroll-margin-top: 80px; }

    /* Scroll-driven reading focus for "The Frontier Way" */
    .company-root .tenet-item { transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1); }
    .company-root .tenet-item .tenet-tag-bold { color: #A9A293; transition: color 0.45s cubic-bezier(0.16, 1, 0.3, 1); }
    .company-root .tenet-item .tenet-tag-sub { color: #C5BFB3; transition: color 0.45s cubic-bezier(0.16, 1, 0.3, 1); }
    .company-root .tenet-item .tenet-text { color: rgba(24, 25, 25, 0.28); transition: color 0.45s cubic-bezier(0.16, 1, 0.3, 1); }
    .company-root .tenet-item.active .tenet-tag-bold,
    .company-root .tenet-item:hover .tenet-tag-bold { color: #181919; }
    .company-root .tenet-item.active .tenet-tag-sub,
    .company-root .tenet-item:hover .tenet-tag-sub { color: #78716C; }
    .company-root .tenet-item.active .tenet-text,
    .company-root .tenet-item:hover .tenet-text { color: #181919; }

    /* Asymmetric press mosaic */
    .company-root .mosaic-tile {
      position: relative;
      overflow: hidden;
      background-color: #090E1A;
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s ease;
    }
    .company-root .mosaic-tile:hover img { transform: scale(1.04); }
    .company-root .mosaic-tile img { transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1), filter 0.4s ease; }
  `}</style>
);
